var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5858 4.5C24.3738 4.5 26.0938 5.20667 27.3591 6.47467C28.6258 7.74 29.3338 9.44667 29.3338 11.2333V21.7667C29.3338 25.4867 26.3071 28.5 22.5858 28.5H9.41381C5.69248 28.5 2.66714 25.4867 2.66714 21.7667V11.2333C2.66714 7.51333 5.67914 4.5 9.41381 4.5H22.5858ZM24.7081 13.2208L24.8148 13.1141C25.1335 12.7274 25.1335 12.1674 24.8001 11.7808C24.6148 11.5821 24.3601 11.4608 24.0948 11.4341C23.8148 11.4194 23.5481 11.5141 23.3468 11.7008L17.3348 16.5008C16.5615 17.1421 15.4535 17.1421 14.6681 16.5008L8.66812 11.7008C8.25346 11.3941 7.68012 11.4341 7.33479 11.7941C6.97479 12.1541 6.93479 12.7274 7.24012 13.1274L7.41479 13.3008L13.4815 18.0341C14.2281 18.6208 15.1335 18.9408 16.0815 18.9408C17.0268 18.9408 17.9481 18.6208 18.6935 18.0341L24.7081 13.2208Z",
    fill: "#0799B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.645807d78a6448b13e191e8ba8a378ab.svg";
export { ForwardRef as ReactComponent };